export class UpdateJobTemplateInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "jobTimeout",
            "baseName": "jobTimeout",
            "type": "number",
            "format": ""
        },
        {
            "name": "retryPolicy",
            "baseName": "retryPolicy",
            "type": "SparkJobRetryPolicy",
            "format": ""
        },
        {
            "name": "sparkSubmitParams",
            "baseName": "sparkSubmitParams",
            "type": "SparkJobSparkSubmitParams",
            "format": ""
        },
        {
            "name": "storageConfig",
            "baseName": "storageConfig",
            "type": "StorageConfig",
            "format": ""
        },
        {
            "name": "eonSparkVersions",
            "baseName": "eonSparkVersions",
            "type": "Array<EonSparkVersion>",
            "format": ""
        },
        {
            "name": "schedule",
            "baseName": "schedule",
            "type": "JobTemplateScheduleInput",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateJobTemplateInput.attributeTypeMap;
    }
    constructor() {
    }
}
